import { FC, MouseEvent, ReactNode } from 'react';
import { Button } from '../ui/button';
import { cn } from 'lib/utils';
import { uiButton } from '../CutCorners';
import { ButtonPart, buttonStates } from './button';

interface BPButtonProps {
  children: ReactNode;
  state?: keyof typeof buttonStates;
  disabled?: boolean;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
}

const BPButton: FC<BPButtonProps> = ({
  children,
  state = 'primary',
  disabled = false,
  onClick = () => {},
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={
        'group/button grid relative w-full h-[56px] bg-transparent hover:bg-transparent rounded-none'
      }
    >
      <Background state={state} />
      <Text state={state}>{children}</Text>
    </Button>
  );
};

const Text: FC<{ children: ReactNode; state: keyof typeof buttonStates }> = ({
  children,
  state,
}) => (
  <div
    className={cn(
      'grid grid-flow-col gap-3 w-auto items-center justify-center relative h-full text-[16px]',
      buttonStates[state].text
    )}
  >
    {children}
  </div>
);

export const ButtonText: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="block relative pt-[4px]">{children}</div>
);

const Background: FC<{ state: keyof typeof buttonStates }> = ({ state }) => {
  const base =
    'block absolute top-0 left-0 w-full h-full pointer-events-none bg-gradient-to-b';

  const getPartClasses = (part: ButtonPart): string =>
    [part.default, part.hover, part.active, part.focus, part.disabled].join(
      ' '
    );

  const bg = getPartClasses(buttonStates[state].bg);
  const border = getPartClasses(buttonStates[state].border);

  return (
    <>
      <div className={cn(base, bg, uiButton.bg)} />
      <div className={cn(base, border, uiButton.border)} />
    </>
  );
};

export default BPButton;
